<template>
  <div class="content">
    <div class="con-header">
      <p class="con-header-title">{{community.title}}</p>
      <p style="height:10%;" class="int-info-con_foot flex-center-start">
        <img class="int-author-icon" src="../../../assets/author_icon.png"/>
        <span class="int-author">作者：{{community.author}} | </span>
        <span class="int-date">{{community.updateTime}}</span>
      </p>
      <div class="con-body">
        <div v-html="community.details" style="text-align: left"></div>
        <div class="con-qrcode">
          <img src="../../../assets/qrcode_bg.png"/>
          <p style="margin-top:20px;font-size:14px;color:#898989">更多干货和案例，可以关注"有必旺"公众号了解</p>
        </div>
      </div>
      <div style="padding:50px 0">
        <button v-if="nextId"
                @click="()=>{
                  $router.push({
                    path:'/wk_community_about',
                    query:{id:nextId}
                  })
                  intent()
                }"
                style="width:120px;height:36px;background: #fff;border-radius:5px;box-shadow: 0 0 5px #a5a5a5;outline: none;border: none">
          下一篇 <i class="el-icon-arrow-right"></i>
        </button>
        <p v-else>已经是最后一篇了</p>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import qs from 'qs'
    export default {
        name: "wk_community_about",
      data(){
        return{
          community:{},
          preId:'',
          nextId:'',
        }
      },
      mounted(){
        this.intent()
      },
      methods:{
          intent(){
            axios({
              method: 'post',
              url:process.env.PUBLIC_URL+'/get_one_article',
              data:qs.stringify({id:this.$route.query.id}),
              timeout: 30000,
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
              }
            }).then((res)=>{
              this.community = res.data[1]
              this.preId = res&&res.data[0]?res.data[0].id:null
              this.nextId = res&&res.data[2]?res.data[2].id:null
            })
          }
      }
    }
</script>

<style scoped>
  @import "../../../style.css";
  @import "./about_pc.css";
  @import "./about_mini.css";
</style>



// WEBPACK FOOTER //
// src/components/wk_community/block/about.vue